var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardLogoDiscover = function SvgCardLogoDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 86,
    fill: "none",
    viewBox: "0 0 64 43"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 41.67,
    x: 0.5,
    y: 0.5,
    fill: "#F9F9FA",
    rx: 6.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 41.67,
    x: 0.5,
    y: 0.5,
    stroke: "#DFE0E5",
    rx: 6.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.206 17.727H9.143v7.131h2.035c1.088 0 1.869-.25 2.567-.832a3.6 3.6 0 0 0 1.31-2.747c0-2.082-1.588-3.552-3.849-3.552m1.62 5.357c-.447.387-1.005.555-1.924.555h-.363V18.92h.363c.893 0 1.45.166 1.924.584.5.444.78 1.11.78 1.776-.001.693-.28 1.386-.78 1.803M17.091 17.727h-1.394v7.131h1.394zM20.522 20.447c-.836-.305-1.087-.499-1.087-.889 0-.444.446-.777 1.033-.777.418 0 .752.166 1.144.584l.725-.971c-.613-.527-1.311-.806-2.121-.806-1.283 0-2.232.888-2.232 2.053 0 1 .446 1.498 1.757 1.97.558.195.836.334.976.417a.85.85 0 0 1 .418.749c0 .583-.475 1-1.087 1-.67 0-1.2-.334-1.534-.944l-.893.832c.64.943 1.422 1.359 2.481 1.359 1.451 0 2.482-.971 2.482-2.358.002-1.109-.47-1.636-2.062-2.22M23.033 21.307c0 2.11 1.645 3.719 3.792 3.719.613 0 1.116-.111 1.757-.416v-1.637c-.558.555-1.059.777-1.7.777-1.423 0-2.399-1.028-2.399-2.47 0-1.358 1.033-2.442 2.344-2.442.67 0 1.171.222 1.757.805v-1.637c-.612-.305-1.116-.445-1.729-.445-2.12-.002-3.823 1.664-3.823 3.746M39.908 22.528l-1.898-4.8h-1.534l3.04 7.326h.755l3.094-7.327H41.86zM44.007 24.858h3.96v-1.193h-2.564v-1.942h2.481V20.5h-2.481v-1.58h2.565v-1.194h-3.961zM53.518 19.836c0-1.333-.922-2.11-2.539-2.11h-2.09v7.13h1.394v-2.854h.195l1.924 2.859h1.729l-2.259-2.998c1.061-.223 1.646-.943 1.646-2.027M50.7 21.003h-.418v-2.165h.418c.865 0 1.34.361 1.34 1.054.028.72-.447 1.11-1.34 1.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-logo-discover_svg__a)",
    d: "M32.99 25.108c2.094 0 3.792-1.69 3.792-3.774s-1.697-3.773-3.792-3.773-3.793 1.689-3.793 3.773 1.698 3.774 3.793 3.774"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-logo-discover_svg__b)",
    d: "M32.99 25.11c2.094 0 3.792-1.69 3.792-3.774a3.784 3.784 0 0 0-3.792-3.775 3.78 3.78 0 0 0-3.793 3.773 3.785 3.785 0 0 0 3.793 3.776",
    opacity: 0.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.494 18.033c0-.14-.083-.194-.251-.194h-.224v.667h.167v-.279l.195.25h.194l-.223-.276c.088-.002.142-.085.142-.168m-.278.083-.028-.166h.028c.084 0 .112.029.112.083s-.057.083-.112.083"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.271 17.56a.57.57 0 0 0-.586.584c0 .333.251.584.586.584.307 0 .587-.25.587-.584-.029-.307-.28-.583-.587-.583m0 1.055a.49.49 0 0 1-.475-.473c0-.277.195-.472.475-.472.252 0 .447.222.447.472 0 .279-.195.473-.447.473"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "card-logo-discover_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.1158 -5.87802 4.58217 -2.40456 34.501 24.073)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF932C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#E86D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E85718",
    stopOpacity: 0.865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#640000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-logo-discover_svg__a",
    x1: 34.932,
    x2: 32.325,
    y1: 24.36,
    y2: 20.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#F99D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F79320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F68820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#F57E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47521"
  })))));
};
export default SvgCardLogoDiscover;